import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DataTableComponent } from '../datatable/datatable.component';

@Component({
	selector: 'app-datatable-carousel',
	styleUrls: ['./datatable-carousel.component.css'],
	templateUrl: './datatable-carousel.component.html'
})
export class DatatableCarouselComponent extends DataTableComponent implements OnInit, OnDestroy {
	@Input() sectiontitle: string;
	@Input() sectionclass: string;
	@Input() key: string;
	@Input() datatableconfig;
	@Input() campaignsData;

	public carouselData = [];
	public carouselOne: NguCarouselConfig;
	public currentIndex = 0;
	// tslint:disable-next-line: prefer-output-readonly
	@Output() updateGraph: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('carousel') carousel: NguCarousel<any>;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
		this.carouselOne = {
			grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
			loop: true,
			point: {
				hideOnSingleSlide: true,
				visible: true
			},
			touch: true,
			velocity: 0.2
		};
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.currentIndex = 0;
			this.requestData();
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
		const containerHeight = jQuery('.carousel-item').height();
		jQuery('<style></style>')
			.appendTo(jQuery('.carousel-item'))
			.text(`#datatable-carousel-container{height:${containerHeight - 150}px !important}`);
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	processResponseData(responseData: any): void {
		this.carouselData = [];
		const groupedData = _.values(_.groupBy(responseData, 'campaign_id'));
		_.map(groupedData, (data, index) => {
			const title =
				this.campaignsData && this.campaignsData[index] && this.campaignsData[index].campaign_name
					? this.campaignsData[index].campaign_name
					: this.campaignsData && this.campaignsData[index] && this.campaignsData[index].name
					? this.campaignsData[index].name
					: '';
			this.generateDateTableV3Configuration(data, title);
		});
	}

	generateDateTableV3Configuration(responseData: any, name: any): void {
		this.dataTableObj.data = this.generateResponseDataFromConfig(responseData);
		this.dataTableObj.campaign_name = name;
		this.carouselData.push(JSON.parse(JSON.stringify(this.dataTableObj)));
	}

	nextArrow(): void {
		if (this.currentIndex >= this.carouselData.length - 1) {
			this.currentIndex = 0;
		} else {
			this.currentIndex += 1;
		}
		const campName = this.carouselData[this.currentIndex].campaign_name;
		this.updateGraph.emit(campName);
	}

	prevArrow(): void {
		if (this.currentIndex === 0) {
			this.currentIndex = this.carouselData.length - 1;
		} else {
			this.currentIndex -= 1;
		}
		const campName = this.carouselData[this.currentIndex].campaign_name;
		this.updateGraph.emit(campName);
	}
}
